import React from 'react';
import Popup from '@components/Popup';
import { NEW_TERM_OF_SERVICE_LINK } from '@constants/constant';
import styles from '../index.module.css';

const TermsOfUsePopup = ({ visible, onPositiveClick, onNegativeClick }) => {
  const MessagesComponent = () => {
    return (
      <>
        <div className={styles.styleTextContent}>
          <a
            href={NEW_TERM_OF_SERVICE_LINK}
            target="_blank"
            className={styles.linkText}
            rel="noreferrer"
          >
            利用規約/プライバシーポリシー
          </a>
          が変更になりました。
        </div>
        <div className={styles.styleTextContent}>
          変更内容を確認の上、ご同意ください。
        </div>
      </>
    );
  };

  return (
    <Popup
      visible={visible}
      bodyStyle={styles.wrapperTermsOfUsePopup}
      title="バチェラーデート 利用規約"
      titleClassName={styles.titleTermsOfUseClassName}
      MessagesComponent={<MessagesComponent />}
      customContentStyle={styles.contentTermsOfUseStyle}
      positiveButtonTitle="利用規約に同意する"
      onPositiveClicked={onPositiveClick}
      positiveButtonClassName={styles.positiveTermsOfUseClass}
      negativeButtonTitle="同意しない"
      negativeButtonClassName={styles.negativeTermsOfUseClass}
      onNegativeClicked={onNegativeClick}
      buttonContainerStyle={styles.termsOfUseButtonContainer}
      disableClose
    />
  );
};

export default TermsOfUsePopup;
